/* ------------------------------------------------------------
   Montrose — recherche « au plus proche » (3 octobre 2026)

   Quoi que tape le visiteur, un soin est proposé : celui dont le nom,
   le geste, le besoin ou les actifs ressemblent le plus aux mots
   saisis (accents ignorés, préfixes acceptés, une faute de frappe
   tolérée). Trois endroits en profitent :

   · le tiroir mobile du header : les cartes apparaissent sous le champ
     dès la deuxième lettre ([data-mon-recherche-tiroir]) ;
   · la page de résultats : les soins trouvés par Shopify sont reclassés
     du plus proche au plus lointain, et s'il n'y en a aucun, les plus
     proches sont affichés quand même ([data-mon-recherche-resultats]) ;
   · le modal de recherche du bureau : même filet de sécurité quand
     Shopify ne renvoie aucun produit.

   Les cartes viennent de la section mon-cartes-catalogue, rendue une
   seule fois par l'API de section (formulaire d'ajout au panier et index
   de recherche inclus), puis clonées. Styles : assets/mon-carte-soin.css.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.monRechercheProche) return;
  window.monRechercheProche = true;

  var SOURCE_URL = '/collections/all?section_id=mon-cartes-catalogue';
  var MIN_LETTRES = 2;
  var cartesPromesse = null;
  var compteur = 0;

  /* ---------- Normalisation ---------- */

  function normaliser(texte) {
    return String(texte || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/œ/g, 'oe')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function mots(texte) {
    return normaliser(texte).split(' ').filter(function (m) { return m.length > 1; });
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    var la = a.length, lb = b.length;
    if (!la) return lb;
    if (!lb) return la;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= lb; j += 1) prev[j] = j;
    for (i = 1; i <= la; i += 1) {
      cur[0] = i;
      for (j = 1; j <= lb; j += 1) {
        var cout = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cout);
      }
      var t = prev; prev = cur; cur = t;
    }
    return prev[lb];
  }

  /* Bigrammes : similarité d'ensemble, utile quand aucun mot ne colle. */
  function bigrammes(s) {
    var out = {};
    s = s.replace(/ /g, '');
    for (var i = 0; i < s.length - 1; i += 1) out[s.substr(i, 2)] = (out[s.substr(i, 2)] || 0) + 1;
    return out;
  }

  function dice(a, b) {
    var ba = bigrammes(a), bb = bigrammes(b), inter = 0, na = 0, nb = 0, k;
    for (k in ba) { na += ba[k]; if (bb[k]) inter += Math.min(ba[k], bb[k]); }
    for (k in bb) nb += bb[k];
    return na + nb ? (2 * inter) / (na + nb) : 0;
  }

  /* ---------- Index et score ---------- */

  function indexer(carte) {
    if (carte.monIndex) return carte.monIndex;
    var titre = normaliser(carte.dataset.mcsTitre);
    carte.monIndex = {
      titre: titre,
      titreCompact: titre.replace(/ /g, ''),
      champs: [
        { poids: 1, mots: mots(carte.dataset.mcsTitre) },
        { poids: 0.6, mots: mots(carte.dataset.mcsMots) },
        { poids: 0.35, mots: mots(carte.dataset.mcsTexte) }
      ]
    };
    return carte.monIndex;
  }

  function scoreMot(q, liste) {
    var meilleur = 0, tolerance = q.length >= 7 ? 2 : q.length >= 4 ? 1 : 0;
    for (var i = 0; i < liste.length; i += 1) {
      var t = liste[i], s = 0;
      if (t === q) s = 1;
      else if (t.indexOf(q) === 0) s = 0.85;
      else if (q.length >= 4 && t.indexOf(q) !== -1) s = 0.6;
      else if (t.length >= 3 && q.indexOf(t) === 0) s = 0.5;
      else if (tolerance && Math.abs(t.length - q.length) <= tolerance) {
        var d = levenshtein(q, t);
        if (d <= tolerance) s = 0.7 - 0.15 * d;
      }
      if (s > meilleur) meilleur = s;
      if (meilleur === 1) break;
    }
    return meilleur;
  }

  function score(requete, carte) {
    var idx = indexer(carte);
    var q = normaliser(requete);
    if (!q) return 0;
    var termes = mots(q);
    var total = 0, touches = 0;
    for (var i = 0; i < termes.length; i += 1) {
      var m = 0;
      for (var c = 0; c < idx.champs.length; c += 1) {
        var s = scoreMot(termes[i], idx.champs[c].mots) * idx.champs[c].poids;
        if (s > m) m = s;
      }
      if (m > 0) touches += 1;
      total += m;
    }
    if (idx.titre.indexOf(q) !== -1) total += 1.5;
    else if (idx.titreCompact.indexOf(q.replace(/ /g, '')) !== -1) total += 1.2;
    if (termes.length > 1 && touches === termes.length) total += 0.5;
    return total;
  }

  /* Classe les cartes ; renvoie toujours au moins une carte. */
  function classer(requete, cartes, max) {
    var notes = cartes.map(function (carte, i) {
      return { carte: carte, i: i, s: score(requete, carte), d: dice(normaliser(requete), indexer(carte).titre) };
    });
    notes.sort(function (a, b) { return (b.s - a.s) || (b.d - a.d) || (a.i - b.i); });
    var tete = notes[0] ? notes[0].s : 0;
    var retenues = notes.filter(function (n) { return n.s > 0 && n.s >= tete * 0.3; });
    if (!retenues.length) retenues = notes.slice(0, 1);
    return retenues.slice(0, max || retenues.length).map(function (n) { return n.carte; });
  }

  /* ---------- Réserve de cartes ---------- */

  function charger() {
    if (cartesPromesse) return cartesPromesse;
    cartesPromesse = fetch(SOURCE_URL, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cartes = Array.prototype.slice.call(doc.querySelectorAll('[data-mcs]'));
        if (!cartes.length) throw new Error('aucune carte');
        return cartes;
      })
      .catch(function (e) { cartesPromesse = null; throw e; });
    return cartesPromesse;
  }

  function cloner(carte, tag) {
    compteur += 1;
    var clone = carte.cloneNode(true);
    clone.querySelectorAll('[id]').forEach(function (el) {
      var id = el.id + '-c' + compteur;
      clone.querySelectorAll('[for="' + el.id + '"]').forEach(function (l) { l.setAttribute('for', id); });
      el.id = id;
    });
    if (tag && tag !== clone.tagName.toLowerCase()) {
      var autre = document.createElement(tag);
      Array.prototype.forEach.call(clone.attributes, function (a) { autre.setAttribute(a.name, a.value); });
      autre.innerHTML = clone.innerHTML;
      clone = autre;
    }
    return clone;
  }

  function remplir(liste, cartes, tag) {
    liste.textContent = '';
    cartes.forEach(function (c) { liste.appendChild(cloner(c, tag)); });
    if (typeof window.monDefileDemarrer === 'function') window.monDefileDemarrer(liste.parentNode || liste);
    var barre = liste.nextElementSibling;
    if (barre && barre.classList.contains('mon-defile')) {
      /* Nouvelle liste : la barre existante est réutilisée, on la réveille. */
      liste.dispatchEvent(new Event('scroll'));
    }
  }

  function urlResultats(q) {
    return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  /* ---------- 1. Tiroir mobile ---------- */

  function monterTiroir(form) {
    var champ = form.querySelector('input[name="q"]');
    var zone = document.querySelector('[data-mon-recherche-tiroir-resultats]');
    if (!champ || !zone) return;
    var liste = zone.querySelector('[data-mon-recherche-liste]');
    var tout = zone.querySelector('[data-mon-recherche-tout]');
    var minuteur = null, derniere = '';

    function fermer() {
      zone.hidden = true;
      derniere = '';
    }

    function afficher() {
      var q = champ.value.trim();
      if (q.length < MIN_LETTRES) { fermer(); return; }
      if (q === derniere) return;
      charger().then(function (cartes) {
        if (champ.value.trim() !== q) return;
        derniere = q;
        remplir(liste, classer(q, cartes, 4), 'li');
        if (tout) tout.href = urlResultats(q);
        zone.hidden = false;
        liste.scrollLeft = 0;
      }).catch(fermer);
    }

    champ.addEventListener('focus', function () { charger().catch(function () {}); });
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(afficher, 140);
    });
    champ.addEventListener('search', function () { if (!champ.value) fermer(); });
  }

  /* ---------- 2. Page de résultats ---------- */

  function monterResultats(zone) {
    var q = zone.dataset.monRechercheTermes || new URLSearchParams(location.search).get('q') || '';
    var liste = zone.querySelector('[data-mon-recherche-liste]');
    if (!liste || q.trim().length < 1) return;
    var presentes = Array.prototype.slice.call(liste.querySelectorAll('[data-mcs]'));

    if (presentes.length) {
      /* Reclassement : le soin dont le nom colle le mieux passe en tête. */
      var ordre = classer(q, presentes, presentes.length);
      var restantes = presentes.filter(function (c) { return ordre.indexOf(c) === -1; });
      ordre.concat(restantes).forEach(function (c) { liste.appendChild(c); });
      return;
    }

    /* Aucun résultat exact : on propose quand même les plus proches. */
    var repli = zone.querySelector('[data-mon-recherche-repli]');
    charger().then(function (cartes) {
      remplir(liste, classer(q, cartes, 4), 'li');
      if (repli) repli.hidden = false;
      zone.classList.add('is-repli');
    }).catch(function () {});
  }

  /* ---------- 3. Modal de recherche (bureau et bouton flottant) ---------- */

  function monterModal(composant) {
    var champ = composant.querySelector('input[name="q"]');
    var contenu = composant.querySelector('.predictive-search-form__content');
    if (!champ || !contenu) return;
    var minuteur = null;

    function verifier() {
      var q = champ.value.trim();
      var ancien = contenu.querySelector('[data-mon-recherche-modal-repli]');
      var produits = contenu.querySelector('.predictive-search-results__card--product, [data-mcs]:not([data-mon-recherche-modal-repli] [data-mcs])');
      if (q.length < MIN_LETTRES || produits || composant.getAttribute('aria-busy') === 'true') {
        if (ancien && (q.length < MIN_LETTRES || produits)) ancien.remove();
        return;
      }
      if (ancien && ancien.dataset.requete === q) return;
      charger().then(function (cartes) {
        if (champ.value.trim() !== q) return;
        var cible = contenu.querySelector('.predictive-search-results__inner') || contenu;
        var bloc = contenu.querySelector('[data-mon-recherche-modal-repli]');
        if (!bloc) {
          bloc = document.createElement('div');
          bloc.className = 'mon-recherche-modal-repli';
          bloc.setAttribute('data-mon-recherche-modal-repli', '');
          bloc.innerHTML =
            '<h4 class="predictive-search-results__title">Les soins les plus proches</h4>' +
            '<ul class="mon-cs-rangee predictive-search-results__wrapper-products" data-mon-recherche-liste data-mon-defile="Soins"></ul>';
        }
        bloc.dataset.requete = q;
        cible.appendChild(bloc);
        remplir(bloc.querySelector('[data-mon-recherche-liste]'), classer(q, cartes, 4), 'li');
      }).catch(function () {});
    }

    champ.addEventListener('focus', function () { charger().catch(function () {}); });
    new MutationObserver(function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(verifier, 60);
    }).observe(contenu, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(verifier, 400);
    });
  }

  /* ---------- Démarrage ---------- */

  function demarrer() {
    document.querySelectorAll('[data-mon-recherche-tiroir]').forEach(function (f) {
      if (!f.monRechercheMonte) { f.monRechercheMonte = true; monterTiroir(f); }
    });
    document.querySelectorAll('[data-mon-recherche-resultats]').forEach(function (z) {
      if (!z.monRechercheMonte) { z.monRechercheMonte = true; monterResultats(z); }
    });
    document.querySelectorAll('#search-modal predictive-search-component').forEach(function (c) {
      if (!c.monRechercheMonte) { c.monRechercheMonte = true; monterModal(c); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  document.addEventListener('shopify:section:load', demarrer);
})();
